import { render, staticRenderFns } from "./AddressAdd.vue?vue&type=template&id=2c1429d6&scoped=true"
import script from "./AddressAdd.vue?vue&type=script&lang=js"
export * from "./AddressAdd.vue?vue&type=script&lang=js"
import style0 from "./AddressAdd.vue?vue&type=style&index=0&id=2c1429d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1429d6",
  null
  
)

export default component.exports